import {
    AddBulkOptionFailureActionType,
    AddBulkOptionSuccessActionType,
    AddOptionFailureActionType,
    AddOptionRequestActionType,
    AddOptionSuccessActionType,
    DeleteBulkOptionFailureActionType,
    DeleteBulkOptionSuccessActionType,
    DeleteOptionFailureActionType,
    DeleteOptionSuccessActionType,
    DuplicateFieldOptionsActionType,
    IFieldOptionsState,
    InitOptionsActionType,
    SelectableOptionsActionTypes,
    UpdateOptionActionType,
} from "./types";
import { Handler } from "./../types/store-types";
import { FieldTypes } from "../fields/types";
import { transformOptions } from "../../helpers/transformOptions";

const initOptions: Handler<IFieldOptionsState, InitOptionsActionType> = (state, { payload: { list } }) => {
    const selectableFields = list
        .map(field => {
            if (
                field.type === FieldTypes.CHECKBOX ||
                field.type === FieldTypes.DROPDOWN ||
                field.type === FieldTypes.RADIO
            ) {
                return { id: field._id, options: field.options };
            }

            return undefined;
        })
        .filter(field => field);

    if (selectableFields.length) {
        const optionsState = selectableFields.reduce((accField, selectableField) => {
            if (selectableField?.id && selectableField?.options) {
                return {
                    ...accField,
                    [selectableField.id]: transformOptions(selectableField.options),
                };
            } else {
                return { ...accField };
            }
        }, {});

        return { ...state, options: { ...optionsState } };
    }
    return state;
};

const addOptionRequest: Handler<IFieldOptionsState, AddOptionRequestActionType> = state => {
    return { ...state, disabled: true };
};

const addOptionSuccess: Handler<IFieldOptionsState, AddOptionSuccessActionType> = (
    state,
    { payload: { fieldId, options } },
) => {
    return {
        ...state,
        options: { ...state.options, ...{ [fieldId]: transformOptions(options) } },
        disabled: false,
    };
};
const addOptionFailure: Handler<IFieldOptionsState, AddOptionFailureActionType> = (state, { payload: { fieldId } }) => {
    return { ...state };
};

const addBulkOptionsSuccess: Handler<IFieldOptionsState, AddBulkOptionSuccessActionType> = (
    state,
    { payload: { fieldId, options } },
) => {
    return {
        ...state,
        options: { ...state.options, ...{ [fieldId]: transformOptions(options) } },
    };
};
const addBulkOptionsFailure: Handler<IFieldOptionsState, AddBulkOptionFailureActionType> = state => {
    return { ...state };
};

const deleteOptionSuccess: Handler<IFieldOptionsState, DeleteOptionSuccessActionType> = (
    state,
    { payload: { fieldId, options } },
) => {
    return {
        ...state,
        options: { ...state.options, ...{ [fieldId]: transformOptions(options) } },
    };
};
const deleteOptionFailure: Handler<IFieldOptionsState, DeleteOptionFailureActionType> = state => {
    return { ...state };
};

const deleteBulkOptionsSuccess: Handler<IFieldOptionsState, DeleteBulkOptionSuccessActionType> = (
    state,
    { payload: { fieldId, options } },
) => {
    return { ...state, options: { ...state.options, ...{ [fieldId]: transformOptions(options) } } };
};
const deleteBulkOptionsFailure: Handler<IFieldOptionsState, DeleteBulkOptionFailureActionType> = state => {
    return { ...state };
};

const updateOption: Handler<IFieldOptionsState, UpdateOptionActionType> = (state, { payload }) => {
    const { fieldId, newValue, optionId } = payload;
    return {
        ...state,
        options: { ...state.options, [fieldId]: { ...state.options[fieldId], [optionId]: newValue } },
    };
};
const updateOptionFailure: Handler<IFieldOptionsState, AddOptionFailureActionType> = state => {
    return { ...state };
};

const duplicateFieldOption: Handler<IFieldOptionsState, DuplicateFieldOptionsActionType> = (
    state,
    { payload: { fieldId, options } },
) => {
    return { ...state, options: { ...state.options, [fieldId]: options } };
};

export const handlersSelectableOptions = {
    [SelectableOptionsActionTypes.INIT_OPTIONS]: initOptions,
    [SelectableOptionsActionTypes.ADD_OPTION_REQUEST]: addOptionRequest,
    [SelectableOptionsActionTypes.ADD_OPTION_SUCCESS]: addOptionSuccess,
    [SelectableOptionsActionTypes.ADD_OPTION_FAILURE]: addOptionFailure,
    [SelectableOptionsActionTypes.ADD_BULK_OPTION_SUCCESS]: addBulkOptionsSuccess,
    [SelectableOptionsActionTypes.ADD_BULK_OPTION_FAILURE]: addBulkOptionsFailure,
    [SelectableOptionsActionTypes.DELETE_OPTION_SUCCESS]: deleteOptionSuccess,
    [SelectableOptionsActionTypes.DELETE_OPTION_FAILURE]: deleteOptionFailure,
    [SelectableOptionsActionTypes.DELETE_BULK_OPTION_SUCCESS]: deleteBulkOptionsSuccess,
    [SelectableOptionsActionTypes.DELETE_BULK_OPTION_FAILURE]: deleteBulkOptionsFailure,
    [SelectableOptionsActionTypes.UPDATE_OPTION]: updateOption,
    [SelectableOptionsActionTypes.UPDATE_OPTION_FAILURE]: updateOptionFailure,
    [SelectableOptionsActionTypes.DUPLICATE_FIELD_OPTIONS]: duplicateFieldOption,
};
